export default {
  ADMIN: 1,
  DOCTOR: 2,
  SECRETARY: 3,
  PATIENT: 4,
  CLINIC: 5,
  UNDEFINED: 6,
};
